// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".allItems-yLSP7 {\n  border-bottom: 1px solid #dddddd;\n}\n.allItems-yLSP7 .item-T-ouh {\n  border-bottom: none;\n}\n.listContainer-c1uy1 .item-T-ouh label:before {\n  top: 16px;\n  left: 12px;\n  width: 22px;\n  height: 22px;\n  font-size: 16px;\n  line-height: 18px;\n}\n.listContainer-c1uy1 .item-T-ouh label:after {\n  top: 27px;\n  left: 23px;\n  width: 34px;\n  height: 34px;\n}\n.list-Ce5cV {\n  height: calc(100% - 145px);\n  position: relative;\n}\n.item-T-ouh {\n  padding: 15px 40px 15px 0;\n  width: calc(100% - 15px);\n  border-bottom: 1px solid #dddddd;\n}\n.item-T-ouh label {\n  padding-left: 42px;\n  font-weight: bold;\n}\n.item-T-ouh.expanded--WCiY {\n  border-bottom: none;\n}\n.empty-Jr3LK {\n  color: #929292;\n  display: inline-block;\n  margin-top: 10px;\n  padding-left: 12px;\n}\n.indeterminate-iMKnJ :before {\n  opacity: 0.54;\n}\n.itemContainer-3G6nR {\n  position: relative;\n}\n.itemContainer-3G6nR:last-child .item-T-ouh, .itemContainer-3G6nR:last-child .childItems-jgMOZ {\n  border-bottom: none;\n}\n.caretContainer-rFeb2 {\n  position: absolute;\n  right: 15px;\n  top: 1px;\n  padding: 24px 10px;\n  cursor: pointer;\n}\n.caret-fMsQz {\n  display: block;\n  width: 0;\n  height: 0;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n.caretDown-U9Fly {\n  border-top: 4px solid;\n}\n.caretUp-HLLfo {\n  border-bottom: 4px solid;\n}\n.childItems-jgMOZ {\n  border-bottom: 1px solid #dddddd;\n  padding-left: 20px;\n  margin-right: 15px;\n}\n.childItems-jgMOZ .item-T-ouh {\n  border-bottom: none;\n}\n", "",{"version":3,"sources":["webpack://./app/EAssessment.UI.Common/app-components/elect-filter/items.less"],"names":[],"mappings":"AAEA;EAEI,gCAAA;AA8GJ;AAhHA;EAIM,mBAAA;AA+GN;AA1GM;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AA4GR;AA1GM;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AA4GR;AAjIA;EA2BI,0BAAA;EACA,kBAAA;AAyGJ;AArIA;EAgCI,yBAAA;EACA,wBAAA;EACA,gCAAA;AAwGJ;AA1IA;EAqCM,kBAAA;EACA,iBAAA;AAwGN;AArGI;EACE,mBAAA;AAuGN;AAjJA;EA+CI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAqGJ;AAvJA;EAuDM,aAAA;AAmGN;AA1JA;EAgEI,kBAAA;AA6FJ;AAjGI;EAEE,mBAAA;AAmGN;AAjKA;EAoEI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AAgGJ;AAxKA;EA4EI,cAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,kCAAA;AA+FJ;AA/KA;EAoFI,qBAAA;AA8FJ;AAlLA;EAwFI,wBAAA;AA6FJ;AArLA;EA4FI,gCAAA;EACA,kBAAA;EACA,kBAAA;AA4FJ;AA1LA;EAiGM,mBAAA;AA4FN","sourcesContent":["@import '@cirrus/legacy/app-components/app/styles/colors/colors-default.less';\n\n:local {\n  .allItems {\n    border-bottom: 1px solid @clr-gray-200;\n    .item {\n      border-bottom: none;\n    }\n  }\n  .listContainer {\n    .item label {\n      &:before {\n        top: 16px;\n        left: 12px;\n        width: 22px;\n        height: 22px;\n        font-size: 16px;\n        line-height: 18px;\n      }\n      &:after {\n        top: 27px;\n        left: 23px;\n        width: 34px;\n        height: 34px;\n      }\n    }\n  }\n\n  .list {\n    height: calc(~'100% - 145px');\n    position: relative;\n  }\n\n  .item {\n    padding: 15px 40px 15px 0;\n    width: calc(~'100% - 15px');\n    border-bottom: 1px solid @clr-gray-200;\n\n    label {\n      padding-left: 42px;\n      font-weight: bold;\n    }\n\n    &.expanded {\n      border-bottom: none;\n    }\n  }\n\n  .empty {\n    color: @clr-gray-870;\n    display: inline-block;\n    margin-top: 10px;\n    padding-left: 12px;\n  }\n\n  .indeterminate {\n    :before {\n      opacity: 0.54;\n    }\n  }\n\n  .itemContainer {\n    &:last-child .item,\n    &:last-child .childItems {\n      border-bottom: none;\n    }\n    position: relative;\n  }\n\n  .caretContainer {\n    position: absolute;\n    right: 15px;\n    top: 1px;\n    padding: 24px 10px;\n    cursor: pointer;\n  }\n\n  .caret {\n    display: block;\n    width: 0;\n    height: 0;\n    border-right: 4px solid transparent;\n    border-left: 4px solid transparent;\n  }\n\n  .caretDown {\n    border-top: 4px solid;\n  }\n\n  .caretUp {\n    border-bottom: 4px solid;\n  }\n\n  .childItems {\n    border-bottom: 1px solid @clr-gray-200;\n    padding-left: 20px;\n    margin-right: 15px;\n\n    .item {\n      border-bottom: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"black": "#000",
	"yellow": "#008859",
	"yellowinprogress": "#BEA66E",
	"blackt30": "rgba(0, 0, 0, 0.3)",
	"black50": "rgba(0, 0, 0, 0.75)",
	"blue100": "#4690d1",
	"blue120": "#2791c6",
	"blue130": "#2196f3",
	"blue150": "#add2f7",
	"blue210": "#287ec7",
	"blue300": "#0478c6",
	"blue400": "#024b7b",
	"blue330": "#0055b0",
	"brown310": "#7f707d",
	"red": "red",
	"red70": "#f7bfb9",
	"red100": "#e87d7d",
	"red300": "#f35958",
	"red320": "#e05251",
	"red405": "#a94442",
	"red410": "#bc2b43",
	"red500": "#cc2d30",
	"red550": "#c60000",
	"red900": "#ff0000",
	"red905": "#cf4444",
	"red910": "#c60000",
	"green200": "#d8f0ea",
	"green210": "#c0e8dc",
	"green250": "#09998d",
	"green270": "#47bcb3",
	"green300": "#008859",
	"green310": "#4cb992",
	"green505": "#119264",
	"green520": "#00794f",
	"green650": "#b1dac6",
	"green700": "#008000",
	"green710": "#30b382",
	"green800": "#008859",
	"yellow90": "#fbdba0",
	"yellow410": "#fedb97",
	"orange200": "#eda04f",
	"orange300": "#ee9a02",
	"orange350": "#e7a257",
	"orange360": "#c3a565",
	"orange380": "#ff8c40",
	"orange400": "#ef7400",
	"orange420": "#ff6600",
	"orange550": "#bf5000",
	"blue170": "#7e9fc2",
	"blue220": "#537fad",
	"blue250": "#2879c7",
	"darkBlue400": "#272c40",
	"blue305": "#0055b0",
	"blue310": "#00829b",
	"brown320": "#7f707d",
	"gray75": "#f6f6f6",
	"gray80": "#eeeeee",
	"gray85": "#ecedec",
	"gray95": "#d9d9d9",
	"gray120": "#e5e9ec",
	"gray200": "#dddddd",
	"gray201": "#f2f2f2",
	"gray214": "#c4c4c4",
	"gray215": "#cccccc",
	"gray220": "#ccd0d3",
	"gray225": "#c1c9cd",
	"gray240": "#cfcfcf",
	"gray230": "#d9edf7",
	"gray245": "#8b8b8b",
	"gray250": "#808080",
	"gray320": "#dedce0",
	"gray400": "#5e5e5e",
	"gray420": "#555555",
	"gray850": "#554854",
	"gray305": "#757575",
	"gray500": "#333333",
	"gray800": "#4a4a4a",
	"gray820": "#40465d",
	"gray855": "#8b91a0",
	"gray280": "#999999",
	"gray50": "#f9f9f9",
	"gray100": "#ececec",
	"gray125": "#e4e4e4",
	"gray235": "#c1bebe",
	"gray350": "#6b546a",
	"gray600": "#f1f1f1",
	"gray720": "#b6b6b6",
	"gray740": "#b6a8b4",
	"gray755": "#ebebeb",
	"gray810": "#525252",
	"gray860": "#9b9b9b",
	"gray870": "#929292",
	"gray890": "#756372",
	"gray895": "#989898",
	"gray910": "#444059",
	"gray925": "#9c9c9c",
	"gray930": "#ddcfac",
	"gray935": "#5f6368",
	"gray920": "#757575",
	"gray950": "#ece4d0",
	"gray1000": "#ebe8e8",
	"gray1010": "#e6e6e6",
	"gray1050": "#e0e6f0",
	"gray1060": "#c6c6c6",
	"gray1100": "#ededed",
	"gray1120": "#8e818c",
	"gray1150": "#212121",
	"purple": "#6a546a",
	"transparent": "transparent",
	"allItems": "allItems-yLSP7",
	"item": "item-T-ouh",
	"listContainer": "listContainer-c1uy1",
	"list": "list-Ce5cV",
	"expanded": "expanded--WCiY",
	"empty": "empty-Jr3LK",
	"indeterminate": "indeterminate-iMKnJ",
	"itemContainer": "itemContainer-3G6nR",
	"childItems": "childItems-jgMOZ",
	"caretContainer": "caretContainer-rFeb2",
	"caret": "caret-fMsQz",
	"caretDown": "caretDown-U9Fly",
	"caretUp": "caretUp-HLLfo"
};
export default ___CSS_LOADER_EXPORT___;
